import { Form, Show, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import routerProvider from "@pankod/refine-react-router-v6";
import { ENUM_TYPE_REQUEST } from "constants/types";
import { useMemo } from "react";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITransaction } from "types/transaction.interface";

export const RequestShow: React.FC<IResourceComponentsProps> = () => {
  const { formProps } = useForm<ITransaction>();

  const { Link } = routerProvider;
  const { queryResult } = useShow<ITransaction>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  const formItems = useMemo(() => {
    return [
      {
        type: "object",
        label: "Track",
        name: "track",
        children: "title",
      },
      {
        label: "Content",
        name: "content",
      },
      {
        label: "Type",
        name: "type",
      },
      {
        type: "object",
        label: "email",
        name: "user",
        children: "email",
      },
    ];
  }, []);

  return (
    <Show isLoading={isLoading} canEdit={false}>
      <Form {...formProps} layout="vertical">
        {formItems.map(({ label, name, type, children }, index) => (
          <Form.Item label={label} name={name} key={index}>
            {type === "object"
              ? record?.data?.[name][children]
              : record?.data[name]}
          </Form.Item>
        ))}
      </Form>
      <Link
        to={
          record?.data?.type === ENUM_TYPE_REQUEST.DOWNLOAD
            ? `/track-purchases/edit/${record?.data?.trackPurchase?._id}`
            : `/users/edit/${record?.data?.user?._id}`
        }
      >
        Response to request
      </Link>
    </Show>
  );
};
